/**
 * Client-contact API client (SSOT for /client/<id>/contacts + /client-contacts/<id>).
 *
 * Thin domain wrapper around window.apiClient for the additional-contacts
 * manager in client_view.js. Exposed on window.contactApi (no ES modules in
 * this codebase yet — same loadOnce pattern).
 *
 * Each method returns a Promise resolving to the parsed `data` payload, or
 * { turboStream: true } when the server returned a Turbo Stream and Turbo has
 * rendered it. Errors throw with .message, .status, and .details set.
 */
loadOnce('contact-api', function () {
    var request = window.apiClient.request;

    window.contactApi = {
        list: function (clientId) {
            return request('GET', '/client/' + encodeURIComponent(clientId) + '/contacts', null, { acceptStream: false });
        },
        create: function (clientId, data, opts) {
            return request('POST', '/client/' + encodeURIComponent(clientId) + '/contacts', data, opts);
        },
        update: function (contactId, data, opts) {
            return request('PUT', '/client-contacts/' + encodeURIComponent(contactId), data, opts);
        },
        remove: function (contactId, opts) {
            return request('DELETE', '/client-contacts/' + encodeURIComponent(contactId), null, opts);
        }
    };
});
